<template>
  <button class="btn"
          :class="[
            ghost ? 'btn-primary-ghost' : 'btn-primary',
            isSmall && 'btn-sm',
            disabled && 'disabled'
          ]"
          :disabled="disabled"
          @click.prevent="clickAction"
  >
    <template v-if="isLoading">
      <i class="fa fa-spinner fa-pulse fa-fw text-sm" />
    </template>
    <template v-else>
      {{ buttonText }}
    </template>
  </button>
</template>

<script>
export default {
  props: {
    clickAction: {
      type: Function,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: true
    },
    ghost: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  }
};
</script>
